import { createSlice, isAnyOf } from "@reduxjs/toolkit";

import { CampaignAxios } from "../../axios/campaign/campaign.axios";
import { CampaignDrip } from "../../model/campaign/CampaignDrip";
import { CreateCampaignDripDto } from "../../model/campaign/dto/CreateCampaignDripDto";
import { UpdateCampaignDripDto } from "../../model/campaign/dto/UpdateCampaignDripDto";
import { GenericWithUserId } from "../../model/shared/dto/GenericWithUserId";
import { AtiraThunk } from "../AtiraThunk";
import { userActions } from "../user/user.slice";
import { revertAllReduxAction } from "../store-reset";

interface CampaignReducer {
  campaigns?: CampaignDrip[];
  selectedCampaign?: CampaignDrip | null;
}

const initialState = Object.freeze<CampaignReducer>({
  campaigns: [],
  selectedCampaign: null,
});

const createCampaign = AtiraThunk<void, CreateCampaignDripDto>(
  "/campaigns/create",
  CampaignAxios.createCampaign,
);

const getCampaigns = AtiraThunk<CampaignDrip[], GenericWithUserId>(
  "/campaigns",
  CampaignAxios.getCampaigns,
);

const updateCampaign = AtiraThunk<void, UpdateCampaignDripDto>(
  "/campaigns/update",
  CampaignAxios.updateCampaign,
);

const campaignSlice = createSlice({
  name: "campaign",
  initialState,
  reducers: {
    setSelectedCampaign(state, action) {
      state.selectedCampaign = action.payload;
    },
  },
  extraReducers: ({ addCase, addMatcher }) => {
    addCase(getCampaigns.fulfilled, (state, action) => {
      state.campaigns = action.payload;
    });

    addMatcher(isAnyOf(userActions.logout, revertAllReduxAction), (state) => {
      return (state = initialState);
    });
  },
});

export const campaignActions = {
  ...campaignSlice.actions,
  createCampaign,
  getCampaigns,
  updateCampaign,
};

export default campaignSlice.reducer;
